import React from 'react'
import classnames from 'classnames'
import styles from './Toast.module.css'
import { default as generalStyle } from '../Theme/GeneralTheme.module.css'

import { LoadingCircle } from '../Loading'

import {
  MdInfo,
  MdWarning,
  MdCheckCircle,
  MdCancel,
  MdClose,
  MdDataUsage,
} from 'react-icons/md'

const POSITIONS = ['bottom_right', 'top_right', 'bottom_left', 'top_left']
const AVAIBLE_STATUS = ['info', 'alert', 'success', 'error', 'verification']
const DEFAULT_POSITION = POSITIONS[0]
const DEFAULT_STATUS = AVAIBLE_STATUS[0]

const ToastContainer = ({ toasts, position = DEFAULT_POSITION, ...props }) => {
  if (!Array.isArray(toasts)) {
    return <React.Fragment />
  }

  function getToastPosition() {
    if (!POSITIONS.some((p) => p === position)) {
      return styles[DEFAULT_POSITION]
    }
    return styles[position]
  }

  const { className, ...rest } = props;
  const childrenClassNames = classnames([
    generalStyle.general_style,
    styles.toast_container,
    getToastPosition(),
  ], className)

  return (
    <div
      className={childrenClassNames}
      {...rest}
    >
      {toasts.map(
        (
          {
            actionTitle,
            closeOnHeader,
            description,
            idToast,
            title,
            status,
            maxWidth,
            minWidth,
            onClose,
            isLoading,
            onClickAction,
          },
          index,
        ) => (
          <Toast
            actionTitle={actionTitle}
            closeOnHeader={closeOnHeader}
            description={description}
            style={{ maxWidth: maxWidth, minWidth: minWidth }}
            id={idToast}
            onClickAction={onClickAction}
            key={index}
            title={title}
            status={status}
            onClose={onClose}
            isLoading={isLoading}
          />
        ),
      )}
    </div>
  )
}

const Toast = ({
  actionTitle,
  closeOnHeader,
  description,
  id,
  title,
  status,
  style,
  onClickAction,
  onClose,
  isLoading,
  ...props
}) => {
  function getToastCardStatus() {
    if (!AVAIBLE_STATUS.some((s) => s === status)) {
      return styles[`toast_status_${DEFAULT_STATUS}`]
    }
    return styles[`toast_status_${status}`]
  }

  const { className, ...rest } = props;
  const childrenClassNames = classnames([
    styles.toast, getToastCardStatus()
  ], className)

  return (
    <div
      style={style}
      className={childrenClassNames}
      {...rest}
    >
      <ToastHeader closeOnHeader={closeOnHeader} id={id} onClose={onClose} />
      <ToastContent
        closeOnHeader={closeOnHeader}
        description={description}
        title={title}
        status={status}
        onClose={onClose}
        isLoading={isLoading}
        id={id}
      />
      <ToastFooter
        actionTitle={actionTitle}
        onClickAction={onClickAction}
      />
    </div>
  )
}

const ToastHeader = ({ closeOnHeader, onClose, id }) => {
  return (
    <React.Fragment>
      {closeOnHeader && (
        <div
          className={classnames([styles.header, generalStyle.clickable])}
          onClick={() => onClose(id)}
        >
          <MdClose />
        </div>
      )}
    </React.Fragment>
  )
}

const ToastContent = ({
  closeOnHeader,
  description,
  title,
  id,
  isLoading,
  status,
  onClose,
}) => {
  const closable = !!onClose && !isLoading && !closeOnHeader

  function getToastIconStatus() {
    switch (status) {
      case 'info':
        return <MdInfo />
      case 'alert':
        return <MdWarning />
      case 'success':
        return <MdCheckCircle />
      case 'error':
        return <MdCancel />
      case 'verification':
        return <MdDataUsage />
      default:
        return null
    }
  }

  return (
    <div
      className={classnames([
        styles.container_toast_content,
        closeOnHeader && styles.closable_margin,
      ])}
    >
      <div className={classnames([styles.content_information])}>
        {getToastIconStatus()}
        <div>
          {title}
          {description && (
            <p
              className={classnames([
                generalStyle.no_spacing,
                styles.toast_description,
              ])}
            >
              {description}
            </p>
          )}
        </div>
      </div>

      {closable && (
        <div
          className={classnames([
            styles.container_toast_close,
            generalStyle.clickable,
          ])}
        >
          <MdClose onClick={() => onClose(id)} />
        </div>
      )}

      {isLoading && (
        <div className={classnames([styles.custom_loading_toast])}>
          <LoadingCircle value={80} indeterminate />
        </div>
      )}
    </div>
  )
}

const ToastFooter = ({ id, actionTitle, onClickAction }) => {
  return (
    <React.Fragment>
      {actionTitle && (
        <div
          className={classnames([styles.toast_action, generalStyle.clickable])}
          onClick={() => onClickAction(id)}
        >
          {actionTitle}
        </div>
      )}
    </React.Fragment>
  )
}

export { ToastContainer }
